export default __webpack_public_path__ + "snacks.239dc252.svg";